import * as S from './styles'
import formatMoney from '../../util/formatMoney'

const OrderPrices = ({
  className,
  value,
  tax,
  freight,
  discount,
  totalValue,
  addition,
  advance,
  paymentDiscount,
  totalDiscount,
}) => {
  // PRD-2634: oculta a exibição do frete quando a empresa trabalha com frete FOB exclusivo
  const hideFreight = JSON.parse(localStorage.getItem('DAuth:customer'))?.environmentConfiguration?.ecommerceHideFreight
  return (
    <S.OrderPrices className={className}>
      <S.OrderPricesItem>
        <S.OrderPricesLabel>Subtotal</S.OrderPricesLabel>
        <S.OrderPricesValue>{formatMoney(value)}</S.OrderPricesValue>
      </S.OrderPricesItem>
      <S.OrderPricesItem>
        <S.OrderPricesLabel>Desconto</S.OrderPricesLabel>
        <S.OrderPricesValue>{formatMoney(discount) || 0} + {formatMoney(paymentDiscount) || 0}</S.OrderPricesValue>
      </S.OrderPricesItem>
      {totalDiscount > 0 && paymentDiscount > 0 && (
        <S.OrderPricesItem>
          <S.OrderPricesLabel>Desconto Total</S.OrderPricesLabel>
          <S.OrderPricesValue>{formatMoney(totalDiscount)}</S.OrderPricesValue>
        </S.OrderPricesItem>
      )}
      <S.OrderPricesItem>
        <S.OrderPricesLabel>Impostos</S.OrderPricesLabel>
        <S.OrderPricesValue>{formatMoney(tax)}</S.OrderPricesValue>
      </S.OrderPricesItem>
      {!hideFreight && (
        <S.OrderPricesItem>
          <S.OrderPricesLabel>Frete</S.OrderPricesLabel>
          <S.OrderPricesValue>{formatMoney(freight)}</S.OrderPricesValue>
        </S.OrderPricesItem>
      )}
      {advance > 0 && (
        <S.OrderPricesItem>
          <S.OrderPricesLabel>Adiantamento</S.OrderPricesLabel>
          <S.OrderPricesValue>{formatMoney(advance)}</S.OrderPricesValue>
        </S.OrderPricesItem>
      )}
      <S.OrderPricesItem>
        <S.OrderPricesLabel>Adição</S.OrderPricesLabel>
        <S.OrderPricesValue>{formatMoney(addition)}</S.OrderPricesValue>
      </S.OrderPricesItem>
      <S.OrderPricesTotal>
        <S.OrderPricesLabelTotal>Total Geral</S.OrderPricesLabelTotal>
        <S.OrderPricesValueTotal>{formatMoney(totalValue)}</S.OrderPricesValueTotal>
      </S.OrderPricesTotal>
    </S.OrderPrices>
  )
}

export default OrderPrices
